import { render, staticRenderFns } from "./Penyebrangan.vue?vue&type=template&id=6264d350&scoped=true"
import script from "./Penyebrangan.vue?vue&type=script&lang=js"
export * from "./Penyebrangan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6264d350",
  null
  
)

export default component.exports